import { Box, Drawer } from "@mui/material";
import ButtonComponent from "../../../Components/Common/button/Button";
import InfoPopover from "../../../Components/Common/poper/InfoPopover";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  setFGBottlerData,
  setFGFilterApplied,
  setFGFinalTreeData,
  setFGSelectedTreeIds,
  setFGTransformedTreeData,
} from "../../../redux/FGEntityTree";
import FGEntitySelector from "./FGEntitySelector";
import ApiService from "../../../utils/fetch";

const FGBottlerSelection = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const filterApplied = useSelector((state) => state.FGentity.FGfilterApplied);
  const email = useSelector((state) => state.user.email);
  const transformedTreeDataRedux = useSelector(
    (state) => state.FGentity.FGtransformedTreeData,
  );

  useEffect(() => {
    if (
      transformedTreeDataRedux === null ||
      transformedTreeDataRedux.length === 0
    ) {
      const postData = async () => {
        try {
          const response = await ApiService.get("/v1/fg/bottler-selection");

          const bottler = response.data[0]?.bottler || "";
          dispatch(setFGBottlerData(bottler));

          const transformedData = transformData(response.data);
          const allIds = getAllIds(transformedData);

          dispatch(setFGTransformedTreeData(transformedData));
          dispatch(setFGSelectedTreeIds(allIds));

          const filteredItems = allIds.filter((item) =>
            item.startsWith("profitCenter"),
          );
          const ApplyTreeViewData = filterBottlersByCountry(
            filteredItems,
            transformedData,
          );

          dispatch(setFGFinalTreeData(ApplyTreeViewData));
          console.log(ApplyTreeViewData, "ApplyTreeViewData Bottler selection");
        } catch (error) {
          console.error("Error posting data", error);
        }
      };
      postData();
    }
  }, [email]);

  // const transformData = (data) => {
  //   return data.map((item, bottlerIndex) => {
  //     const displayLabel = item.bottlerOwnerCode
  //       ? `${item.bottler} - ${item.bottlerOwnerCode}`
  //       : item.bottler;

  //     return {
  //       id: `bottler-${bottlerIndex + 1}`,
  //       label: displayLabel,
  //       bottler: item.bottler,
  //       bottlerOwnerCode: item.bottlerOwnerCode,
  //       children: (item.profitCenterDescription || []).map(
  //         (pcDesc, countryIndex) => ({
  //           id: `profitCenter-${bottlerIndex + 1}-${countryIndex + 1}`,
  //           label: pcDesc,
  //           profitCenterDescription: pcDesc,
  //           bottler: item.bottler,
  //           bottlerOwnerCode: item.bottlerOwnerCode,
  //         }),
  //       ),
  //     };
  //   });
  // };

  const transformData = (data) => {
    return data.map((item, bottlerIndex) => {
      const displayLabel = item.bottlerOwnerCode
        ? `${item.bottler} - ${item.bottlerOwnerCode}${
            item.bottlerOwnerDescription
              ? ` - ${item.bottlerOwnerDescription}`
              : ""
          }`
        : item.bottler;

      return {
        id: `bottler-${bottlerIndex + 1}`,
        label: displayLabel,
        bottler: item.bottler,
        bottlerOwnerCode: item.bottlerOwnerCode,
        bottlerOwnerDescription: item.bottlerOwnerDescription, // optional but safe
        children: (item.profitCenterDescription || []).map(
          (pcDesc, countryIndex) => ({
            id: `profitCenter-${bottlerIndex + 1}-${countryIndex + 1}`,
            label: pcDesc,
            profitCenterDescription: pcDesc,
            bottler: item.bottler,
            bottlerOwnerCode: item.bottlerOwnerCode,
            bottlerOwnerDescription: item.bottlerOwnerDescription,
          }),
        ),
      };
    });
  };

  const filterBottlersByCountry = (profitCenterIds, transformedData) => {
    const groupedData = {};

    (transformedData ?? []).forEach((bottler) => {
      (bottler.children ?? [])
        .filter((country) => profitCenterIds.includes(country.id))
        .forEach((country) => {
          const ownerCode = country.bottlerOwnerCode || "";
          const countryName = country.profitCenterDescription || "";

          if (!groupedData[ownerCode]) {
            groupedData[ownerCode] = [];
          }

          if (!groupedData[ownerCode].includes(countryName)) {
            groupedData[ownerCode].push(countryName);
          }
        });
    });

    return Object.entries(groupedData).map(
      ([bottlerOwnerCode, countryList]) => ({
        bottlerOwnerCode,
        countryList,
      }),
    );
  };

  //get all Ids
  const getAllIds = (items) => {
    const ids = [];
    items.forEach((item) => {
      ids.push(item.id);
      if (item.children) {
        ids.push(...getAllIds(item.children));
      }
    });
    return ids;
  };

  // toggler handler
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(open);
  };

  // handle call back for closing toggle box
  const handleCallback = (isOpen) => {
    setOpen(isOpen);
  };

  const clearFilterHandler = () => {
    dispatch(setFGFilterApplied(false));
    const allIds = getAllIds(transformedTreeDataRedux);
    const filteredItems = allIds.filter((item) =>
      item.startsWith("profitCenter"),
    );
    const ApplyTreeViewData = filterBottlersByCountry(
      filteredItems,
      transformedTreeDataRedux,
    );
    dispatch(setFGFinalTreeData(ApplyTreeViewData));
    dispatch(setFGSelectedTreeIds(allIds));
  };

  return (
    <>
      <div>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {filterApplied ? (
            <div
              onClick={clearFilterHandler}
              style={{
                color: "grey",
                cursor: "pointer",
                textDecoration: "underline",
                marginRight: "10px",
              }}
            >
              Clear Filter
            </div>
          ) : (
            <div></div>
          )}
          <ButtonComponent
            maxWidth="200px"
            label="Select Bottler"
            bgColor="black"
            color="white"
            onClick={toggleDrawer(true)}
            height="25px"
          />
          <InfoPopover />
        </Box>

        <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
          <FGEntitySelector popupHandler={handleCallback} />
        </Drawer>
      </div>
    </>
  );
};

export default FGBottlerSelection;
